import { CatalogGenres } from "./settings";


const formatCatalogSource = (format, catalog) => {
    let formatSelection = 'TV';
    for (const key in catalog) {
        if (Object.hasOwnProperty.call(catalog, key)) {
            const element = catalog[key];
            if (element === format) {
                formatSelection = element;
            }
        }
    }

    return formatSelection;
}
const AnimeApiFormatAnimeData = (data = {}) => {
    const { id, titles, episodes_count, score, genres, descriptions, format, cover_image, banner_image, status } = data;
    const fourCategories = (genres?.length > 0) ? genres.slice(0, 4) : [];
    const description = (Object.entries(descriptions || {}).length > 0) ? descriptions?.en : '';
    const type = formatCatalogSource(format, CatalogGenres);

    return {
        id,
        title: titles?.en || '',
        episodes: episodes_count,
        score,
        categories: fourCategories,
        description,
        type,
        images: {
            cover: cover_image,
            banner: banner_image
        },
        status
    }
}
const AnimeApiFormatCapituleData = (data) => {
    const { anime_id, number, title, video, video_headers } = data;

    return {
        id: anime_id,
        title,
        number,
        video,
        video_headers
    }
}
export const AnimeApiFormatCapituleList = ({ documents }) => {
    const animeList = documents?.map((anime) => {
        return AnimeApiFormatCapituleData(anime);
    })
    return animeList || {}
}
export const AnimeApiFormatList = ({ documents }) => {
    const animeList = documents.map((anime) => {
        return AnimeApiFormatAnimeData(anime);
    })
    return animeList
}
export const AnimeApiFormatAnime = (data) => {
    /* let format = useMemo(() => AnimeApiFormatAnimeData(data), [data]); */
    return AnimeApiFormatAnimeData(data);
}